// extracted by mini-css-extract-plugin
module.exports = {"editor_container":"ChatInput_editor_container__30cZK","user_typing":"ChatInput_user_typing__3jJlJ","placeholder":"ChatInput_placeholder__3RbeO"};